import { render, staticRenderFns } from "./two-columns.vue?vue&type=template&id=77ff3346&scoped=true&"
import script from "./two-columns.vue?vue&type=script&lang=js&"
export * from "./two-columns.vue?vue&type=script&lang=js&"
import style0 from "./two-columns.vue?vue&type=style&index=0&id=77ff3346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff3346",
  null
  
)

export default component.exports